import { MotionBox } from '@/components/common/Motion';
import PlentySpinner, {
    PlentySpinnerProps,
    plentySpinnerVariants,
} from './PlentySpinner';

export interface PlentyFullScreenSpinnerProps extends PlentySpinnerProps {
    spinnerSize?: number;
    onAnimationComplete?: () => void;
    dynamicLines?: string[];
    onDynamicLinesComplete?: () => void;
}

export default function PlentyFullScreenSpinner({
    onAnimationComplete,
    message,
    spinnerSize,
    dynamicLines,
    onDynamicLinesComplete,
    ...props
}: PlentyFullScreenSpinnerProps) {
    return (
        <MotionBox
            position="fixed"
            background="white"
            top={0}
            right={0}
            w="100vw"
            h="100vh"
            zIndex={999999}
            variants={plentySpinnerVariants}
            initial="enter"
            animate="center"
            {...props}
        >
            <PlentySpinner
                size={spinnerSize}
                message={message}
                onAnimationComplete={onAnimationComplete}
                dynamicLines={dynamicLines}
                onDynamicLinesComplete={onDynamicLinesComplete}
            />
        </MotionBox>
    );
}
